import React from 'react';
import {Route, Routes, Navigate} from "react-router-dom";
import Home from "../adminPages/home";
import Protected from "../adminPages/protected";
import Header from "../layouts/admin/header";
import Navbar from "../layouts/admin/navbar";
import CarouselSliderUpdate from "../adminPages/home/updates/carouselSliderUpdate";
import About from "../adminPages/about";
import BrandProfile from "../layouts/brandProfile";
import Footer from "../layouts/footer";
import LatestNewsUpdate from "../adminPages/home/updates/latestNewsUpdate";
import Services from "../adminPages/home/updates/services";
import ServiceDetailsUpdate from "../adminPages/home/updates/serviceDetailsUpdate";
import StakeholdersUpdate from "../adminPages/home/updates/stakeholdersUpdate";
import ActsRulesOrders from "../adminPages/actsRulesOrders";
import MediaEvent from "../adminPages/mediaEvent";
import UpdateMediaEvent from "../adminPages/mediaEvent/update/updateMediaEvent";
import Guideline from "../adminPages/guideline";
import FAQ from "../adminPages/faq";
import Contact from "../adminPages/contect";
import Notices from "../adminPages/allNotices";
import ServiceCreatePage from "../adminPages/home/updates/ServiceCreatePage";

const PrivateRoutes = () => {
    return (
        <>
            <Header/>
            <Navbar/>
            <Routes>
                <Route path="/" element={<Navigate to='/admin/home'/>}/>
                <Route path='/admin/home' element={<Protected Component={Home}/>}/>
                <Route path='/admin/about' element={<Protected Component={About}/>}/>
                <Route path='/admin/home/carousel' element={<Protected Component={CarouselSliderUpdate}/>}/>
                <Route path='/admin/home/latest-news' element={<Protected Component={LatestNewsUpdate}/>}/>
                <Route path='/admin/services' element={<Protected Component={Services}/>}/>
                <Route path='/admin/services/:id' element={<Protected Component={ServiceDetailsUpdate}/>}/>
                <Route path='/admin/services/new' element={<Protected Component={ServiceCreatePage}/>}/>
                <Route path='/admin/home/stakeholders' element={<Protected Component={StakeholdersUpdate}/>}/>
                <Route path='/admin/home/notices' element={<Protected Component={Notices}/>}/>
                <Route path='/admin/services' element={<Protected Component={Services}/>}/>
                <Route path='/admin/acts-rules-orders' element={<Protected Component={ActsRulesOrders}/>}/>
                <Route path='/admin/media-events' element={<Protected Component={MediaEvent}/>}/>
                <Route path='/admin/media-events/:id' element={<Protected Component={UpdateMediaEvent}/>}/>
                <Route path='/admin/guidelines' element={<Protected Component={Guideline}/>}/>
                <Route path='/admin/faqs' element={<Protected Component={FAQ}/>}/>
                <Route path='/admin/contacts' element={<Protected Component={Contact}/>}/>
                <Route path="*" element={<Navigate to='/admin/home'/>}/>
            </Routes>
            <BrandProfile/>
            <Footer/>
        </>
    );
};

export default PrivateRoutes;
